import { useEffect, useRef } from "react";
import { matchRoutes, useLocation } from "react-router-dom";
import routes from "../../router/config";
import { trackVisit } from "../../lib/trackVisit";

/**
 * Registra una visita cada vez que cambia la ruta.
 * Se monta una sola vez en la app (junto a ScrollToTop) y no renderiza nada.
 * Las rutas que no existen (página 404) no se registran.
 */
export default function VisitTracker() {
  const { pathname } = useLocation();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    if (lastPath.current === pathname) return;
    lastPath.current = pathname;
    const matches = matchRoutes(routes, pathname);
    const route = matches?.[matches.length - 1]?.route;
    if (!route || route.path === "*") return;
    trackVisit(pathname);
  }, [pathname]);

  return null;
}
